var EHDI = EHDI || Object.create(null);

EHDI.debugUtils = EHDI.debugUtils || Object.create(null);

EHDI.debugUtils.debugUtilsContainer = function(version) {
    EHDI.aka.Container.call(this);
    
    var fpsDisplay  = new EHDI.debugUtils.FPSDisplay();
    fpsDisplay.anchor.y = 1;
    fpsDisplay.position.set( 10, APP.config.stageHeight );
    this.addChild( fpsDisplay );
    
    var versionDisplay = new EHDI.aka.PixiText(version, {fontFamily: 'proximanova-black', fill: 0xFFFFFF, dropShadow : true, fontSize: 32});
    versionDisplay.anchor.x = 1;
    versionDisplay.anchor.y = 1;
    versionDisplay.position.set( APP.config.stageWidth - 10, APP.config.stageHeight );
    
    this.addChild( versionDisplay );
    
    
};

EHDI.debugUtils.debugUtilsContainer.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.debugUtils.FPSDisplay = function() {
    this.fps = APP.managers.update.getFPS();
    EHDI.aka.PixiText.call(this, "FPS : " + this.fps, {fontFamily: 'proximanova-black', fill: 0xFFFFFF, dropShadow : true, fontSize: 32});
    
    APP.managers.update.addFrameListener(this.updateMe.bind(this));
};

EHDI.debugUtils.FPSDisplay.prototype = Object.create(EHDI.aka.PixiText.prototype);

EHDI.debugUtils.FPSDisplay.prototype.updateMe = function() {
    if(this.fps !== APP.managers.update.getFPS()) {

        var str =  "FPS :" + APP.managers.update.getFPS();
        
        if ( this.text !== str ) this.text = str;
    }
        
};
